// No longer needed in Angular 13
// import * as angular from 'angular';
// import { createHostListener } from '@angular/compiler/src/core';
import { homeModule } from './home.module';
declare const window: any;

/**
 * The controller for the `app` component.
 */
// class AuthedController {
//   //data
//   emailAddress;
//   isAuthenticated;


//   private $ = window.$;

//   static $inject = ['AppConfig', 'AuthService', '$state'];
//   constructor( AppConfig, public AuthService, public $state) {
//     this.emailAddress = AppConfig.emailAddress;
//     this.isAuthenticated = AuthService.isAuthenticated();
//   }


//   logout() {
//     let {AuthService, $state} = this;
//     AuthService.logout();
//     // Reload states after authentication change
//     return $state.go('welcome', {}, { reload: true });
//   }
// }

class AuthedController { 
  constructor(){}
}

/**
 * This is the main app component for an authenticated user.
 *
 * This component renders the outermost chrome (application header and tabs, the compose  and logout button)
 * It has a `ui-view` viewport for nested states to fill in.
 */
const appComponent = {
  controller: AuthedController,
  controllerAs: "ctrl",
//   template: `
// <div  class="container-fluid">
//   <div class="row">
//   <div class="col-lg-2 col-md-2 leftPanel">
//     <app-menu></app-menu>
//   </div>
//   <div class="col-lg-10 col-md-10">
//     <div ui-view/>
//   </div>
//   </div>
 
// </div>
// `

  templateUrl: '/app/home/app.component.html'


};

// homeModule.directive('app', appComponent);

homeModule.directive('app', () => appComponent);
